import { render, staticRenderFns } from "./GDanAudit.vue?vue&type=template&id=31437a24&scoped=true&"
import script from "./GDanAudit.vue?vue&type=script&lang=js&"
export * from "./GDanAudit.vue?vue&type=script&lang=js&"
import style0 from "./GDanAudit.vue?vue&type=style&index=0&id=31437a24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31437a24",
  null
  
)

export default component.exports